import { render, staticRenderFns } from "./yrityslainaa-5000-euroa.vue?vue&type=template&id=2722fdc1&"
import script from "./yrityslainaa-5000-euroa.vue?vue&type=script&lang=js&"
export * from "./yrityslainaa-5000-euroa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports